import PhotoUploader from "@/components/wizard/PhotoUploader";

export default function StepRoomPhotos({ data, update }) {
  return (
    <div className="space-y-6" data-testid="step-room-photos">
      <div>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Room photos</h2>
        <p className="mt-2 text-slate-600">
          Please upload a few photos of the rooms or areas you'd like cleared.{" "}
          <span className="text-[#FF7F00] font-medium">At least one photo is required</span> so we
          can plan the right van and crew.
        </p>
      </div>

      <div className="rounded-2xl bg-[#FFF7EE] border border-[#FFB870] p-5">
        <PhotoUploader
          label="Room photos (mandatory)"
          value={data.room_photos}
          onChange={(v) => update({ room_photos: v })}
          testIdPrefix="room-photo"
          min={1}
        />
        <p className="mt-3 text-xs text-slate-500">
          JPG, PNG or WEBP up to 15MB each. Add as many as you like.
        </p>
      </div>
    </div>
  );
}
